var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClear(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9A9A9A",
    d: "M7 0a7 7 0 100 14A7 7 0 007 0zm3.053 9.293a.537.537 0 01-.76.76L7 7.76l-2.293 2.293a.536.536 0 11-.76-.76L6.24 7 3.947 4.707a.537.537 0 11.76-.76L7 6.24l2.293-2.293a.537.537 0 01.76.76L7.76 7l2.293 2.293z"
  })));
}
SvgClear.displayName = 'Clear';
export default SvgClear;